import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import ChooseGenerateType from '../forms/ChooseGenerateType'
import PropTypes from 'prop-types'
import Receipt from './Receipt'
import DocService from '../export/DocService'

export default class DownloadFile extends Component {
    static defaultProps = {
        downloadText: 'Select the format of the file you want to download',
        files: [], // [{targetElement, name}]
        renderFile: Receipt
    }

    static propTypes = {
        downloadText: PropTypes.string,
        renderFile: PropTypes.element
    }

    constructor(props) {
        super(props)
    
        this.state = {
             generateType: ' ',
             isDownloading: false
        }
    }
    

    render() {
        const { downloadText } = this.props;

        return (
            <>
                {this.renderFiles()}
                <div className="download-text">{downloadText}</div>
                {this.renderChooseGenerateType()}
            </>
        )
    }

    renderFiles = () => {
        const { files, renderFile: File } = this.props;

        return (
            <div className="theme--default" id="export-file">
                {files.map((file, index) => {
                    return (
                        <File ref={`file${index}`} exportOnly />
                    )
                })}
            </div>
        )
    }

    renderChooseGenerateType = () => {
        const { generateType, isDownloading } = this.state;

        return (
            <ChooseGenerateType 
                types={['pdf', 'jpg']} 
                onChange={this.handleGenerateTypeChange} 
                defaultType={generateType} 
                showLabel
                enableActive={false}
                isLoading={isDownloading}
                size="lg"
            />
        )
    }

    handleGenerateTypeChange = (type) => {
        this.setState({ generateType: type, isDownloading: true });
        setTimeout(() => {
            if(type === 'pdf') {
                this.downloadPdf()
            } else if (type === 'jpg') {
                this.downloadJpg();
            }
        }, 10)
    }

    handleGenerateEnd = () => {
        this.setState({ isDownloading: false });
    }

    downloadPdf = () => {
        const { files } = this.props;
        const isMulti = files.length > 1;
        const fileName = 'Receipt';

        // const withRef = files.map((file, index) => ({
        //     ...file,
        //     targetElement: this.fileNode(index)
        // }))

        const targetElements = files.map((file, index) => this.fileNode(index))

        if(isMulti) {
            DocService.exportMultiPagePdf(targetElements, fileName, this.handleGenerateEnd);
        } else {
            const file = files[0];
            
            DocService.exportPdf(this.fileNode(), file.name, this.handleGenerateEnd);
        }
    }

    downloadJpg = () => {
        const { files } = this.props;
        const isMulti = files.length > 1;

        const withRef = files.map((file, index) => ({
            ...file,
            targetElement: this.fileNode(index)
        }))

        if(isMulti) {
            DocService.exportZip(withRef, 'jpg', 'zip_report', this.handleGenerateEnd);
        } else {
            const file = files[0];

            DocService.exportJpg(this.fileNode(), file.name, this.handleGenerateEnd);
        }
    }
    
    fileNode = (idx = 0) => ReactDOM.findDOMNode(this.fileRef(idx));
    fileRef = (idx = 0) => this.refs[`file${idx}`];
}